export const objectToQueryString = obj => {
  let query = '';
  for (let key in obj) {
    if (obj.hasOwnProperty(key) && !!obj[key]) {
      query += `${key}=${obj[key]}&`;
    }
  }
  return query.slice(0, -1);
};
